// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"e8d9b849","82":"e8d9b849"}[chunkId] + ".chunk.css";
};